/**
 * Rolled Steel Bulb Angle Section Data
 * Indian Standard Bulb Angles (ISBA)
 * 
 * Data source: ROLLED STEEL BULB ANGLES dimensions and properties.csv
 * 
 * Essential Variables (11 total):
 * 1. h - Overall depth/height (mm)
 * 2. b - Flange width (mm)
 * 3. tw - Web thickness (mm)
 * 4. tf - Flange thickness (mm)
 * 5. D - Bulb diameter (mm)
 * 6. r1 - Root radius (mm)
 * 7. r2 - Toe radius (mm)
 * 8. r3 - Internal fillet radius (mm)
 * 9. Cxx - Centroid from X-X axis (cm)
 * 10. Cyy - Centroid from Y-Y axis (cm)
 * 11. tanAlpha - tan(α) for principal axis rotation
 */

export interface RolledSteelBulbAngleData {
  designation: string;
  size: string;         // h×b in mm
  h: number;            // Overall depth (mm)
  b: number;            // Flange width (mm)
  tw: number;           // Web thickness (mm)
  tf: number;           // Flange thickness (mm)
  D: number;            // Bulb diameter (mm)
  r1: number;           // Root radius (mm)
  r2: number;           // Toe radius (mm)
  r3: number;           // Internal fillet radius (mm)
  Cxx: number;          // Centroid X-X (cm)
  Cyy: number;          // Centroid Y-Y (cm)
  exx: number;          // Distance to extreme fiber X-X (cm)
  eyy: number;          // Distance to extreme fiber Y-Y (cm)
  tanAlpha: number;     // tan(α) - principal axis rotation
  w: number;            // Weight (kg/m)
  a: number;            // Area (cm²)
  Ixx: number;          // Moment of Inertia X-X (cm⁴)
  Iyy: number;          // Moment of Inertia Y-Y (cm⁴)
  Iuu: number;          // Moment of Inertia U-U Max (cm⁴)
  Ivv: number;          // Moment of Inertia V-V Min (cm⁴)
  rxx: number;          // Radius of Gyration X-X (cm)
  ryy: number;          // Radius of Gyration Y-Y (cm)
  ruu: number;          // Radius of Gyration U-U Max (cm)
  rvv: number;          // Radius of Gyration V-V Min (cm)
  Zxx: number;          // Section Modulus X-X (cm³)
  Zyy: number;          // Section Modulus Y-Y (cm³)
}

/**
 * Database of Rolled Steel Bulb Angle sections
 * Using first 2 sections from CSV for testing
 */
export const rolledSteelBulbAngles: RolledSteelBulbAngleData[] = [
  {
    designation: 'ISBA 100',
    size: '100×65',
    h: 100,
    b: 65,
    tw: 6,
    tf: 6,
    D: 13,
    r1: 10,
    r2: 5,
    r3: 4,
    Cxx: 3.92,
    Cyy: 1.43,
    exx: 6.08,
    eyy: 5.07,
    tanAlpha: 0.291,
    w: 8.6,
    a: 10.94,
    Ixx: 142.9,
    Iyy: 33,
    Iuu: 153,
    Ivv: 22.8,
    rxx: 3.61,
    ryy: 1.74,
    ruu: 3.74,
    rvv: 1.44,
    Zxx: 23.5,
    Zyy: 6.5
  },
  {
    designation: 'ISBA 125',
    size: '125×75',
    h: 125,
    b: 75,
    tw: 7,
    tf: 7,
    D: 16,
    r1: 11,
    r2: 5.5,
    r3: 5,
    Cxx: 5.06,
    Cyy: 1.6,
    exx: 7.44,
    eyy: 5.9,
    tanAlpha: 0.248,
    w: 12.2,
    a: 15.6,
    Ixx: 321.8,
    Iyy: 60.4,
    Iuu: 338.9,
    Ivv: 43.3,
    rxx: 4.54,
    ryy: 1.97,
    ruu: 4.66,
    rvv: 1.67,
    Zxx: 43.2,
    Zyy: 10.2
  }
];
